// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"279":"0f6969a5","534":"23a67cd5","794":"2bb4d2da","831":"cf8d0a3a"}[chunkId] + ".css";
};